module.exports = __webpack_public_path__ + "img/littleCurve.4232e573.png";